module.exports = __webpack_public_path__ + "img/Merchant.cb95e2e9.png";